import { createSlice } from '@reduxjs/toolkit'
import * as asyncActions from './customers.asynActions'
import { RECORDS_PER_PAGE } from './customers.constants'

const initialState = {
	accounts: [],
	users: [],
	selectedCustomerModal: null,
	customerFilters: {
		sort: 'activationDate',
		sortOrder: 'asc',
		page: 1,
		limit: RECORDS_PER_PAGE,
	},
	selectedAccounts: [],
	selectedRow: {},
	selectedAccount: [],
	customerPlans: [],
	previousFilters: {},
	ffls: {},
}

const slice = createSlice({
	name: 'customers',
	initialState,
	reducers: {
		setCustomerFilters(state, action) {
			state.customerFilters = { ...state.customerFilters, ...action.payload }
		},
		setSelectedCustomerModal(state, action) {
			state.selectedCustomerModal = action.payload
		},
		setSelectedAccounts(state, action) {
			state.selectedAccounts = action.payload || initialState.selectedAccounts
		},
		resetUsers(state) {
			state.users = initialState.users
		},
		setSelectedRow(state, action) {
			state.selectedRow = action.payload
		},
		setSelectedAccount(state, action) {
			state.selectedAccount = action.payload
		},
		setPreviousFilters(state, action) {
			state.previousFilters = action.payload
		},
		resetAccount(state) {
			state.accounts = initialState.accounts
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(asyncActions.fetchCustomers.fulfilled, (state, action) => {
				state.accounts = action.payload || initialState.accounts
			})
			.addCase(asyncActions.fetchCustomerUsers.fulfilled, (state, action) => {
				state.users = action.payload || initialState.users
			})
			.addCase(asyncActions.fetchPlans.fulfilled, (state, action) => {
				state.customerPlans = action.payload || initialState.customerPlans
			})
			.addCase(asyncActions.fetchFFLs.fulfilled, (state, action) => {
				state.ffls = action.payload || initialState.ffls
			})
	},
})

export default slice

export const { name, actions, reducer } = slice
